import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'projectformat',
    templateUrl: 'projectformat.html'
})
export class Projectformat implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/projectformat/projectformat.ts